<template>
    
    <div>
        
        <div id="div-movil-img-home">
        <img id="image-landing-home-movil" v-if="show" style="animation-duration: .5s" class="points-banner-landing h-100 w-100"
                         src="@/assets/images/home-movil.png" alt="Movil Img">
        </div>
        <div>
        <transition name="benefits-fade">
            <UserInternal v-if="show2"/>
        </transition>
        <b-row class="point-container" id="point-container">
            <b-col cols="12" lg="12" id="point-content-imagen" class="div-desktop-img-home">
                <transition :name="clasSlideFade">
                    <img id="image-landing-home-desktop" v-if="show" style="animation-duration: .5s" class="points-banner-landing h-100 w-100"
                         src="@/assets/images/home-imagen.png" alt="Home Gox img">
    
                </transition>
                <transition
                        enter-active-class="animated slideInUp"
                        leave-active-class="animated slideOutLeft">
                    <div v-if="show" v-b-visible.350="visitHandler" class="points-content-titulo-principal" style="animation-duration: 1.5s">
                        <p class="point-titulo"  v-html="content.titulo"></p>
                    </div>
                </transition>
               
            </b-col>
            <transition enter-active-class="animated slideInUp" leave-active-class="animated slideOutLeft">
                <b-col cols="12" lg="12" id="point-content-polygon">
                    <b-row v-if="show" style="animation-duration: 1.5s;" class="d-flex justify-content-between">
                        
                        <b-col cols="12"  md="12" lg="6" class="point-position-polygon-left point-fondo-polygon-left">
                            <b-row class="point-container-titulo">
                                <b-col cols="12" lg="6">
                                    <p class="point-bloque-titulo" v-html="content.bloque1.titulo"></p>
                                </b-col>
                                <b-col cols="12" lg="6" class="point-contentedor-bloque pt-1">
                                    <b-row>
                                        <p class="point-bloque-content-l" v-html="content.bloque1.content"></p>
                                    </b-row>
                                    <b-row class="pt-2">
                                        <div class="point-contet-button">
                                            <button class="button-primary-point" @click="goRouter('/usuario','usuario')">
                                            <span class="button-text-point">{{content.bloque1.texto_boton}}
                                                <img src="@/assets/images/arrow_left.svg" alt="Left Arrow img">
                                            </span>
                                            </button>
                                        </div>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="12"  md="12" lg="6" class="point-position-polygon-right point-fondo-polygon-right">
                            <b-row class="point-container-titulo">
                                <b-col cols="12" lg="6">
                                    <p class="point-bloque-titulo" v-html="content.bloque2.titulo"></p>
                                </b-col>
                                <b-col cols="12" lg="6" class="point-contentedor-bloque pt-1">
                                    <b-row class="">
                                        <p class="point-bloque-content-r" v-html="content.bloque2.content"></p>
                                    </b-row>
                                    <b-row class="pt-2">
                                        <div class="point-contet-button">
                                            <button class="button-primary-point" @click="goRouter('/negocio','negocio')">
                                            <span class="button-text-point">{{content.bloque2.texto_boton}}
                                                <img src="@/assets/images/arrow_left.svg" alt="Left Arrow img">
                                            </span>
                                            </button>
                                        </div>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </transition>
        </b-row>
        </div>
        
    </div>
</template>
<script>
    import UserInternal from '@/views/Web/UserInternal'
//    import CommerceInternal from '@/views/Web/CommerceInternal'
    import EventBus from '@/bus/index'

    export default {
        name: 'section-points',
        components: {
            UserInternal,
//            CommerceInternal
        },
        props: {content: Object},
        data: () => ({
            show: true,
            show2: false,
            show3: false,
            sectionBenefits: {
                fondo: ''
            },
            clasSlideFade: 'slide-fade'
        }),
        methods: {

            visitHandler(isVisible) {
                if (isVisible) {
                    // Do something
                } else {
                    // Do something else
                }
            },
            goRouter(url, tipo) {
                this.show = !this.show
                EventBus.$emit('show-panel', this.show)
                if (tipo === 'comercio') {
                    this.clasSlideFade = 'benefits-fade'
                }
                setTimeout(() => {
                    if (tipo === 'usuario') {
                        this.show2 = !this.show2
                    }
                    if (tipo === 'comercio') {
                        this.show3 = !this.show3
                    }
                    setTimeout(() => {
                        this.$router.push(url)
                    }, 1000, url);
                }, 800, url, tipo);
            }
        }
    }
</script>
<style scoped>
    .slide-fade-enter-active {
        transition: all 1.3s ease-in-out;
    }
    .slide-fade-leave-active {
        transition: all 1.8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateY(50rem);
        opacity: 0;
    }

    .benefits-fade-enter-active {
        transition: all .5s ease;
    }

    .benefits-fade-enter, .benefits-fade-leave-to{
        transition: all .5s ease;
        transform: translate(1650px,0);
        -webkit-transform: translate(1650px,0); /** Safari & Chrome **/
        -o-transform: translate(1650px,0); /** Opera **/
        -moz-transform: translate(1650px,0); /** Firefox **/
    }

    #div-movil-img-home {
        display: none;
    }

    @media (max-width: 600px) {

        #div-movil-img-home {
        display: flex;
        }

        .div-desktop-img-home{
            display: none;
        }

    }

    

</style>